import clsx from "clsx";

type FakeLinkProps = {
  isActive: boolean;
  title: string;
  onHover: () => void;
  isDarkArrow: boolean;
};

const FakeLink: React.FunctionComponent<FakeLinkProps> = (
  { title, isActive, onHover, isDarkArrow },
) => {
  return (
    <li
      onMouseEnter={onHover}
      className={clsx("cursor-pointer text-6xl flex items-center mt-3")}
    >
      <span className={clsx({ hidden: !isActive }, "mr-3")}>
        <svg
          width="48"
          viewBox="0 0 68 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 20.0786C1.79086 20.0786 0 21.8695 0 24.0786C0 26.2878 1.79086 28.0786 4 28.0786V24.0786V20.0786ZM62 24.0786L65.0429 26.6749L67.2818 24.0508L65.0154 21.4505L62 24.0786ZM47.5154 1.37184C46.0639 -0.293533 43.5372 -0.466915 41.8718 0.984579C40.2065 2.43607 40.0331 4.96279 41.4846 6.62816L44.5 4L47.5154 1.37184ZM41.4571 41.9931C40.0232 43.6737 40.2232 46.1984 41.9037 47.6323C43.5843 49.0662 46.1091 48.8662 47.5429 47.1856L44.5 44.5894L41.4571 41.9931ZM4 24.0786V28.0786H62V24.0786V20.0786H4V24.0786ZM44.5 4L41.4846 6.62816L58.9846 26.7068L62 24.0786L65.0154 21.4505L47.5154 1.37184L44.5 4ZM62 24.0786L58.9571 21.4824L41.4571 41.9931L44.5 44.5894L47.5429 47.1856L65.0429 26.6749L62 24.0786Z"
            fill={isDarkArrow ? "white" : "black"}
          />
        </svg>
      </span>
      <span className={clsx({ "opacity-50": !isActive })}>{title}</span>
    </li>
  );
};

export default FakeLink;
